<ng-container *ngIf="navigated">
  <m4-progress type="line"></m4-progress>
</ng-container>
<div class="grid bg-light h-vh-100 m-2" *ngIf="!navigated">
  <div class="row">
    <div class="col-lg-4 col-md-4 col-sm-6 border
        bd-black border-left-none border-bottom-none border-top-none">
      <div class="login-box">
        <form action="javascript:"
              data-role="validator"
              data-clear-invalid="2000"
              [formGroup]="signinForm"
              (ngSubmit)="onSigninUser()"
              class="bg-light p-4">
          <img src="{{logo}}" alt="logo" class="avatar place-right mt-4-minus mr-3">
          <h1 class="mb-0"> {{'Login' | translate}}</h1>
          <div class="text-muted mb-4">
            {{'Sign in to start your session' | translate}}
          </div>
          <div class="form-group">
            <input type="text" data-role="input"
                   formControlName="username"
                   data-validate="required"
                   data-append="<span class='mif-user'>"
                   placeholder="{{'username' | translate}}">
            <span class="invalid_feedback">{{'Please enter a valid email address'  | translate}}</span>
          </div>
          <div class="form-group">
            <input type="password" data-role="input"
                   formControlName="password"
                   data-validate="required"
                   data-append="<span class='mif-key'>"
                   placeholder="{{'password' | translate}}">
            <span class="invalid_feedback">{{'Please enter a password'  | translate}}</span>
          </div>
          <div class="form-group d-flex flex-align-center flex-justify-between">
            <input type="checkbox" data-role="checkbox" [attr.data-caption]="'REMEMBER_ME' | translate">
            <button type="submit" class="button primary">{{'Sign In' | translate}}</button>
          </div>
        </form>
      </div>
    </div>
    <div class="col-md-8 col-sm-6 d-flex flex-justify-center bg-light flex-align-center
    border bd-black border-right-none border-bottom-none border-top-none">
      <img src="../../../../assets/erp-bhh-login-page.jpg" alt="Fond Ecran">
    </div>
    <div class="col-md-12 bg-light"></div>
  </div>
</div>
